import React from 'react'
import { useSelector } from 'react-redux'
import { makeStyles, Typography } from '@material-ui/core'
import { Highlighted } from '../../root/components/common/highlighted'
import { TableVirtualized } from '../../root/components/common/table-virtualized/table'
import { HOT_SWAP_STATUS } from '../constants/constants'
import HotSwapShowDeviceLabel from './how-swap-show-device-label'
import moment from 'moment'

export default function HotSwapOrdersTable({
    hotSwaps,
    search,
    onRowClick,
    sorting,
    onSort,
    isLoading
}) {
    const classes = useStyles()
    const { locale } = useSelector(state => state.main)

    const columns = [
        {
            key: 'id',
            label: 'ID',
            sortable: false,
            dataType: 'string',
            width: 1,
            minWidth: 100,
            render: ({ rowData }) => {
                return (
                    <Typography
                        className={classes.locationCellDiv}
                        variant="inherit"
                        noWrap>
                        <Highlighted text={rowData.id} highlight={search} />
                    </Typography>
                )
            }
        },
        {
            key: 'hotSwapType',
            label: locale.hotSwap.hotSwapType,
            sortable: false,
            dataType: 'string',
            width: 1.5,
            minWidth: 140,
            render: ({ rowData }) => {
                return (
                    <Typography
                        className={classes.hotswapTypeCellDiv}
                        variant="inherit"
                        noWrap>
                        <Highlighted
                            text={rowData.hotswap_type}
                            highlight={search}
                        />
                    </Typography>
                )
            }
        },
        {
            key: 'customer',
            label: locale.customers.customer,
            sortable: true,
            dataType: 'string',
            width: 1.5,
            minWidth: 140,
            render: ({ rowData }) => {
                return (
                    <Typography
                        className={classes.locationCellDiv}
                        variant="inherit"
                        noWrap>
                        <Highlighted
                            text={rowData.customer}
                            highlight={search}
                        />
                    </Typography>
                )
            }
        },
        {
            key: 'location',
            label: locale.locations.location,
            sortable: true,
            dataType: 'string',
            width: 1.5,
            minWidth: 140,
            render: ({ rowData }) => {
                return (
                    <Typography
                        className={classes.locationCellDiv}
                        variant="inherit"
                        noWrap>
                        <Highlighted
                            text={rowData.location}
                            highlight={search}
                        />
                        <Highlighted
                            text={rowData.parentLocation}
                            highlight={search}
                        />
                    </Typography>
                )
            }
        },
        {
            key: 'date',
            label: locale.hotSwap.update_service.summary.date,
            sortable: true,
            dataType: 'string',
            width: 1.5,
            minWidth: 140,
            render: ({ rowData }) => {
                return (
                    <Typography
                        className={classes.locationCellDiv}
                        variant="inherit"
                        noWrap>
                        <Highlighted
                            text={moment(rowData.date).format('DD.MM.YYYY')}
                            highlight={search}
                        />
                        {rowData.time !== '00:00:00' && (
                            <Highlighted
                                text={moment(rowData.time, 'HH:mm:ss').format(
                                    'HH:mm'
                                )}
                                highlight={search}
                            />
                        )}
                    </Typography>
                )
            }
        },
        {
            key: 'responsibleOrTracking',
            label: locale.hotSwap.responsibleOrTracking,
            sortable: false,
            dataType: 'string',
            width: 2,
            minWidth: 160,
            render: ({ rowData }) => {
                return (
                    <Typography
                        className={classes.locationCellDiv}
                        variant="inherit"
                        noWrap>
                        <Highlighted
                            text={rowData.responsibleOrTracking || ''}
                            highlight={search}
                        />
                    </Typography>
                )
            }
        },
        {
            key: 'devices',
            label: locale.devices.devices,
            sortable: false,
            dataType: 'string',
            width: 1,
            minWidth: 140,
            render: ({ rowData }) => {
                return (
                    <div className={classes.labelWrapper}>
                        <HotSwapShowDeviceLabel
                            deviceQuantity={rowData.devices}
                            search={search}
                        />
                    </div>
                )
            }
        },
        {
            key: 'status',
            label: locale.locations.status,
            sortable: true,
            dataType: 'string',
            width: 1.5,
            minWidth: 140,
            render: ({ rowData }) => {
                return (
                    <Typography noWrap variant="inherit">
                        <div
                            className={`${classes.labelWrapper} ${
                                rowData.status === HOT_SWAP_STATUS.open
                                    ? classes.statusOpen
                                    : rowData.status === HOT_SWAP_STATUS.shipped
                                    ? classes.statusShipped
                                    : classes.statusFinished
                            }`}>
                            <Highlighted
                                text={rowData.status}
                                highlight={search}
                            />
                        </div>
                    </Typography>
                )
            }
        }
    ]

    return (
        <TableVirtualized
            data={hotSwaps}
            columns={columns}
            width={100}
            rowHeight={70}
            onRowClick={rowObject => onRowClick(rowObject.rowData)}
            sorting={sorting}
            onSort={onSort}
            isLoading={isLoading}
        />
    )
}

const useStyles = makeStyles(theme => ({
    locationCellDiv: {
        display: 'flex',
        flexDirection: 'column',
        fontSize: 14,
        fontWeight: 500,
        gap: '3px'
    },
    hotswapTypeCellDiv: {
        display: 'flex',
        flexDirection: 'column',
        fontSize: 14,
        fontWeight: 500,
        gap: '3px'
    },
    labelWrapper: {
        borderRadius: theme.borderRadius,
        fontWeight: 500,
        fontSize: '12px',
        padding: '3px 6px',
        backgroundColor: theme.grayLight
    },
    statusOpen: {
        color: theme.gray,
        backgroundColor: theme.grayLight
    },
    statusShipped: {
        color: theme.blue,
        backgroundColor: theme.blueLight
    },
    statusFinished: {
        color: theme.green,
        backgroundColor: theme.greenLight
    }
}))
